"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerActionComponent = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class PlayerActionComponent extends gotti_1.Component {
    constructor() {
        super(Constants_1.SYSTEMS.PLAYER_ACTION);
        this.repeatingAction = false;
    }
    startAction(action, direction, repeatingAction) {
        if (this.action) {
            this.stopAction();
        }
        this.action = action;
        this.actionDirection = direction;
        this.repeatingAction = !!repeatingAction;
        this.emit('start-action', { action, direction });
    }
    stopAction() {
        const prev = this.action;
        const prevDir = this.actionDirection;
        this.action = null;
        this.actionDirection = null;
        this.emit('stop-action', { action: prev, direction: prevDir });
    }
}
exports.PlayerActionComponent = PlayerActionComponent;
//# sourceMappingURL=module.js.map